import * as React from "react"
import { batch } from "@preact/signals-react"
import { Box, Skeleton, Typography } from "@mui/material"
import { SelectSeeker } from "@ui-seeker/core"

import { customerSelectedID } from "@signals"
import { PRICING_CONFIG_MODE_OPTIONS } from "../@constants"
import { customerSetup, modeChangeAcknowledged, pricingConfigMode } from "../@signals"
import ManagementPricingConfigSetupSummary from "./SetupSummary"


/** Step 2 of the form: which reference price this customer uses.
 *
 * Not part of `CommonFilters`: it selects nothing from the backend and changing it must not need a
 * submit — it swaps which branch is on screen and which read is fired. Its value is **preset from
 * the customer's real setup** (`usePricingConfigSetup`), so opening a customer shows what it is.
 *
 * Every change resets the acknowledgment: this is a change of `DIPI_USER.role`, and the warning
 * next to it has to be accepted again.
 */
export default function ManagementPricingConfigModeSelect({ isLoading = false }) {

    if (!customerSelectedID.value) return <></>
    if (isLoading) return <Skeleton variant="rectangular" height={56} />

    return <Box display="flex" alignItems="center" flexWrap="wrap" gap={2}>
        <Typography variant="body2" color="text.secondary" sx={{ flexShrink: 0 }}>
            Reference price
        </Typography>

        <SelectSeeker
            options={PRICING_CONFIG_MODE_OPTIONS}
            value={pricingConfigMode.value}
            onChange={e => batch(() => {
                pricingConfigMode.value = e.target.value
                modeChangeAcknowledged.value = false
            })}
            label="Mode"
            multiple={false}
            disabled={!customerSetup.value}
            sx={{ minWidth: 260 }}
        />

        <ManagementPricingConfigSetupSummary />
    </Box>
}
